import { loginService } from 'services';
import { getUserDetails } from './userController';
import { setAuthorization } from './controller';
import { setFlag } from './flags';
import { signupService } from 'services/authentication/signup';
import { verifyEmailService } from 'services/authentication/verifyEmail';
import { resendVerificationEmailService } from 'services/authentication/resendVerificationEmail';

export const login = async (emailId, password) => {
  try {
    const { status, authToken } = await loginService(emailId, password);

    await setAuthorization(authToken);

    const user = await getUserDetails();

    if (status !== 200) {
      console.error('Error', status);
      return {
        error: true,
        msg: 'Email and/or password is wrong.',
      };
    }
    setFlag('login', true);
    return user.response && user.response.onBoarded;
  } catch (e) {
    console.error(e);
    return {
      error: true,
      msg: 'Email and/or password is wrong.',
    };
  }
};

export const signup = async ({
  firstName,
  lastName,
  workEmail,
  companyName,
  enterPassword,
}) => {
  try {
    const { status, data } = await signupService({
      emailId: workEmail,
      organizationName: companyName,
      password: enterPassword,
      phone: '0',
      subscribedProduct: ['API'],
      timeZone: '',
      userName: firstName + ' ' + lastName,
    });

    if (status !== 201) {
      console.error('Error', data);
      return {
        error: true,
        msg:
          data.response &&
          data.response.error &&
          data.response.error.faultDetail
            ? data.response.error.faultDetail[0]
            : 'Some error occured while signing up. Please contact support.',
      };
    }
    setFlag('login', true);
    return data.response && data.response.onBoarded;
  } catch (e) {
    console.error(e);
    return {
      error: true,
      msg:
        e.response && e.response.error && e.response.error.faultDetail
          ? e.response.error.faultDetail[0]
          : 'Some error occured while signing up. Please contact support.',
    };
  }
};

export const verifyEmail = async ({ emailId, secretCode }) => {
  try {
    const { status, data } = await verifyEmailService({ emailId, secretCode });

    if (status !== 200) {
      console.error('Error', data);
      return {
        error: true,
        msg:
          data.response &&
          data.response.error &&
          data.response.error.faultDetail
            ? data.response.error.faultDetail[0]
            : 'OTP is not valid.',
      };
    }

    return true;
  } catch (e) {
    console.error(e);
    return {
      error: true,
      msg:
        e.response && e.response.error && e.response.error.faultDetail
          ? e.response.error.faultDetail[0]
          : 'OTP is not valid.',
    };
  }
};

export const resendVerificationEmail = async (emailId) => {
  try {
    const { status, data } = await resendVerificationEmailService(emailId);

    if (status !== 200) {
      console.error('Error', data);
      return {
        error: true,
        msg:
          data.response &&
          data.response.error &&
          data.response.error.faultDetail
            ? data.response.error.faultDetail[0]
            : 'Some error occured. Please contact support.',
      };
    }

    return true;
  } catch (e) {
    console.error(e);
    return {
      error: true,
      msg:
        e.response && e.response.error && e.response.error.faultDetail
          ? e.response.error.faultDetail[0]
          : 'Some error occured. Please contact support.',
    };
  }
};

export const logout = () => {
  setAuthorization();
};
